import { HStack, IconButton, Tooltip } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import ChevronRight from 'components/Icons/ChevronRight';
import Close from 'components/Icons/Close';
import { getBlockDriversData } from 'redux/PlanPageSlice';

interface Properties {
  isPanelHidden: boolean;
  onTogglePanel: () => void;
  bottom?: string;
}

const HideButton = ({ isPanelHidden, onTogglePanel, bottom }: Properties) => {
  const blockDrivers = useSelector(getBlockDriversData);
  if (!blockDrivers?.length) {
    return <></>;
  }
  return (
    <HStack
      position='absolute'
      bottom={bottom || '5'}
      left='0'
      display={{ base: 'none', md: 'flex' }}
      zIndex={100}
    >
      <Tooltip label={isPanelHidden ? 'Show panel' : 'Hide panel'}>
        <IconButton
          aria-label='close panel'
          h='8'
          w='8'
          bgColor='violet.900'
          borderColor='violet.900'
          borderTopLeftRadius='none'
          borderBottomLeftRadius='none'
          onClick={onTogglePanel}
        >
          {isPanelHidden ? (
            <ChevronRight width={5} height={5} color='white' />
          ) : (
            <Close width={4} height={4} />
          )}
        </IconButton>
      </Tooltip>
    </HStack>
  );
};

export default HideButton;
